/*================ Brand Bar Factory
  ========================================*/
angular
  .module('vppApp')
  .factory('brandBarFactory', brandBarFactory);

brandBarFactory.$inject = ['$http', '$rootScope', '$log', 'vppConfig', '$state', 'splitFilter', 'ProgramInfoService', 'VarientService'];

function brandBarFactory($http, $rootScope, $log, vppConfig, $state, splitFilter, ProgramInfoService, VarientService) {
  return function() {
    var Url;
    var noVarient = "";
    var thisVarient;
    var programCode;
    var getVarient = VarientService.getVarientName();
    /* === comment when varient needs to work ===*/
    // thisVarient = noVarient;
    /* === uncomment when varient needs to work ===*/
    if (getVarient && ($state.current.name === 'promote.main')) {
     thisVarient = "-" + getVarient;
    } else {
     thisVarient = noVarient;
    }
    // check for program name for overview pages
    if ($state.current.name === 'overview') {

       programCode = ProgramInfoService.getProgramCode().toLowerCase();
       var programName = ProgramInfoService.getProgramName();
       programName = programName.replace(/\s+/g, '-').toLowerCase();
    }
    // check for supplier and emp overview pages
    if (($state.includes('overview')) && ($rootScope.siteCode === 'emp' || $rootScope.siteCode === 'sup')) {
        if (!programCode) {
          programCode = splitFilter($state.current.name, '.', 1);
        }
        var d = new Date().getFullYear().toString().substr(-2);
        if (programCode == 'soty' + d) {
          // programCode = 'soty';
        }

       Url = vppConfig.brandBarContentPath + "brandBar-" + programCode + ".json";
    } else {
      if ($state.includes('overview')) {
        Url = vppConfig.brandBarContentPath + "brandBar-" + programCode + ".json";
      } else {
        Url = vppConfig.brandBarContentPath + "brandBar-" + splitFilter($state.current.name, '.', 0) + thisVarient + ".json";
      }
    }

    var promise = $http.get(Url).then(function successCallback(data) {
      return data;
    }, function errorCallback(data) {
      return data;
    });

    return promise;
  };

 }
